import { combineReducers } from "@reduxjs/toolkit"
import AuthReducer from './auth-slice';
import ContactReducer from './contact-slice';
import MessageReducer from './common/message-slice';
import CartItemReducer from "./common/cart-slice";
import amazonItemsReducer from "./amazon/amazon-slice";
import buyNowModalReducer from "./modal/modal-slice";
import userReducer from "./user";

const rootReducer = combineReducers({
  auth: AuthReducer,
  contact: ContactReducer,
  messages: MessageReducer,
  cartItem: CartItemReducer,
  amazon: amazonItemsReducer,
  buyNowModal: buyNowModalReducer,
  user: userReducer,
})
export default rootReducer

export type RootState = ReturnType<typeof rootReducer>